import { CommonModule, JsonPipe } from '@angular/common';
import { Component, computed, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DashboardDialogFramePart, DialogAction, DialogContext } from '@eforall/dashboard';


@Component({
	selector: 'sized-dialog',
	imports: [
		CommonModule,
		DashboardDialogFramePart,
		JsonPipe,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './sized.dialog.html',
})
export class SizedDialog {

	okAction: DialogAction = {
		id: 'ok',
		cssClass: signal(undefined),
		enabled: signal(true),
		visible: signal(true),
		text: signal('Ok'),
		linkType: 'no-action',
		willCloseDialog: true,
	};
	actions: DialogAction[] = [this.okAction];

	icon = signal('far fa-square');
	header = signal('Body Size Example');

	public readonly dialog = inject<DialogContext<{}>>(MAT_DIALOG_DATA);
	public readonly dialogRef = inject(MatDialogRef<SizedDialog>);

	public readonly width = computed(() => this.dialog.dimensions().bodyWidth);
	public readonly height = computed(() => this.dialog.dimensions().bodyHeight);

}
